import { ActionDescriptor } from '../common/commonTypes';
import MultiplyAttributeForm from './MultiplyAttributeForm';

const multiplyAttribute: ActionDescriptor = {
	FormComponent: MultiplyAttributeForm,
	actionTitle: 'Multiply',
};

export default multiplyAttribute;
